export default __webpack_public_path__ + "static/media/autotomia–tumannyy.5a3437bb.mp3";